import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PriceDisplay } from "@/components/ui/price-display";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import type { DiscountSalonBreakdownShape } from "../../types/discount-analytics-types";

interface Props {
  rows: DiscountSalonBreakdownShape[];
}

export function DiscountSalonBreakdownTable({ rows }: Props) {
  const { t } = useTranslation("reports");

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">{t("discounts.salonBreakdown.title")}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t("discounts.salonBreakdown.salonName")}</TableHead>
              <TableHead className="text-right">
                {t("discounts.salonBreakdown.redemptions")}
              </TableHead>
              <TableHead className="text-right">
                {t("discounts.salonBreakdown.amountDiscounted")}
              </TableHead>
              <TableHead className="text-right">{t("discounts.salonBreakdown.revenue")}</TableHead>
              <TableHead className="text-right">
                {t("discounts.salonBreakdown.uniqueCustomers")}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.salonId}>
                <TableCell className="font-medium">{row.salonName}</TableCell>
                <TableCell className="text-right">{row.redemptionCount}</TableCell>
                <TableCell className="text-right">
                  <PriceDisplay amount={row.totalAmountDiscounted} />
                </TableCell>
                <TableCell className="text-right">
                  <PriceDisplay amount={row.totalDiscountedRevenue} />
                </TableCell>
                <TableCell className="text-right">{row.uniqueCustomers}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
